<template>
    <div>
        <nav-breadcrumb :menu="[{label: '面签详情'}]"/>
        <panel label="贷款信息">
            <el-form label-width="170px" class="xzformitemmb">
                <el-row>
                    <panel border>
                        <el-col :span="12">
                            <el-form-item label="贷款编号 ：">
                                {{financingDetail.fi__transactionNo}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="financingDetail.dfi__withEquitySwap=='N'">
                            <el-form-item label="贷款状态：">
                                {{'Financing_'+ financingDetail.fi__transactionStatus|Status2CN}}

                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="financingDetail.dfi__withEquitySwap=='Y'">
                            <el-form-item label="贷款状态：">
                                {{'Financing_'+ financingDetail.fi__transactionStatus|Status2CN}}<span style="color: red">({{financingDetail.dfi__equitySwap.transactionStatus|Status2CN}})</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="客户名称：">
                                {{financingDetail.fi__customerName}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="客户手机号：">
                                {{financingDetail.ba__customerContactNo}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="渠道商：">
                                {{financingDetail.dealer__dealerName}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">

                            <el-form-item label="贷款金额：">
                                {{financingDetail.fi__totalAmount|formatMoney}} 元
                            </el-form-item>
                            <el-form-item label="贷款申请日期：">
                                {{financingDetail.fi__transactionDate|moment('YYYY-MM-DD')}}
                            </el-form-item>
                            <el-form-item label="贷款开始日期：">
                                {{financingDetail.fi__startDate|moment('YYYY-MM-DD')}}
                            </el-form-item>
                            <el-form-item label="贷款合同利率：">
                                {{financingDetail.fi__interestRate}}% （{{financingDetail.fi__interestType|Status2CN}}）
                            </el-form-item>
                            <el-form-item label="留存收益率：">
                                {{financingDetail.dfi__interestRate}}% （{{financingDetail.dfi__interestType|Status2CN}}）
                            </el-form-item>
                            <!--                <el-form-item label="利息收取节点：">
                            {{financingDetail.fi__interestPayTime}}
                            </el-form-item>-->
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="贷款产品：">
                                {{financingDetail.ct__productName}}
                            </el-form-item>
                            <el-form-item label="是否调整期限">
                                &nbsp;<el-checkbox true-label="Y" false-label="N" v-model="financingDetail.fi__endDateFixed" disabled></el-checkbox>
                            </el-form-item>
                            <el-form-item label="贷款结束日期：">
                                {{financingDetail.fi__endDate|moment('YYYY-MM-DD')}}
                            </el-form-item>
                            <!--                <el-form-item label="贷款比例：">
                            {{financingDetail.ct__financingRatio}}%
                            </el-form-item>-->

                            <!--                <el-form-item label="费用收取节点：">
                            {{financingDetail.fi__lendingFeePayTime}}
                            </el-form-item>-->
                            <el-form-item label="还款期数（月）：">
                                {{financingDetail.fi__repaymentCount}}
                            </el-form-item>
                            <el-form-item label="还款方式：">
                                {{financingDetail.fi__repaymentFormula|Status2CN}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="罚息复利率：">
                                {{financingDetail.fi__penaltyInterestRate}}% （年利率）
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="贷款用途：">
                                {{financingDetail.fi__intendedUse}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="还款码">
                                {{financingDetail.fi__repaymentCode}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="收款账号：">
                                {{financingDetail.cb__accountNo}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="开户行：">
                                {{financingDetail.cb__bank}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="户名：">
                                {{financingDetail.cb__accountName}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="代理人：">
                                {{financingDetail.fi__proxyPersonName}}
                            </el-form-item>
                        </el-col>
                    </panel>
                </el-row>
            </el-form>
        </panel>
        <panel label="身份验证" class="zhengjianxinxi">
           <span v-for="(item, idx) in files" :key="idx" >
               <photo-browser v-model="item.f__fileId" type='image' :label="item.f__fileType"/>
           </span>

        </panel>
        <panel label="签约文件" class="zhengjianxinxi">
            <div class="zhenjianyyzz zhenjianyyzz2" v-for="(item, idx) in financingDetail.contracts" :key="idx" >
                <file-upload   v-model="item.c__fileURL" :editable="false" ></file-upload>{{item.c__title}}
            </div>
        </panel>
        <panel label="视频文件" class="zhengjianxinxi">
           <!-- <span v-for="(item, idx) in videos" :key="idx" >
               <photo-browser v-model="item.f__fileId" type='image' :label="item.f__fileType"/>
           </span>-->
            <div class="zhenjianyyzz zhenjianyyzz2" v-for="(item, idx) in videos" :key="idx" >
                <video-upload   v-model="item.f__fileId" :editable="false" ></video-upload>{{item.f__fileType}}
            </div>
        </panel>
        <div class="tr xzmt">
            <el-button @click="$router.go(-1)">返回</el-button>
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import citysOptions from '../../utils/citys'
    import Status2CN from "../../filters/Status2CN";
    import moment from 'moment'
    export default {
        name: "signing",
        data() {
            return {
                transactionId:this.$route.query['transactionId']||'',
                financingDetail:{},
                files:[],
                videos:[]
            }
        },
        filters: {

            Status2CN
        },
        mounted() {
            if(this.transactionId){
                this.getData()

            }
        },
        watch:{
        },
        methods:{
            getData:function(){
                xhr.getViewSigningTx({
                        'fi.transactionId': this.transactionId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.financingDetail = res.data.data

                                this.financingDetail.files.forEach(item=>{
                                    if(this.financingDetail.contracts.find(items=>items.c__referenceId == item.f__fileRef)){
                                        this.financingDetail.contracts.find(items=>items.c__referenceId == item.f__fileRef).c__fileURL = item.f__fileId
                                    }else{
                                        if(item.f__fileType=='Video'){
                                            this.videos.push(item)
                                        }else{
                                            this.files.push(item)
                                        }

                                    }

                                })

                            }
                        }catch (e) {

                        }
                    })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/signing.vue